import { render } from "./LoggerDetail.vue?vue&type=template&id=1e545845&scoped=true"
import script from "./LoggerDetail.vue?vue&type=script&lang=js"
export * from "./LoggerDetail.vue?vue&type=script&lang=js"

import "./LoggerDetail.vue?vue&type=style&index=0&id=1e545845&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e545845"]])

export default __exports__